export default "__VITE_ASSET__C3vFk0Cn__"